// $ = $Query.noConflict(); 

$(window).on('load', function()
{
    console.log('hi there');
});

$(function() {

    $('button[type="submit"]').on('click', function() {
        // console.log('clicky');
        $(this).find('span').val('Processing...').attr('disabled', 'disabled');

        $(this).validate({
            submitHandler: function(form) {
                $('#form').submit();
            }
        });
    });

    $('.navbar-toggler[data-id=headers-1-sidebar-toggle]').click(function(e) {
        e.preventDefault();
        $('#headers-1-sidebar').toggleClass('show');
    });
    $('.navbar-toggler[data-id=headers-1-sidebar-close]').click(function(e) {
        e.preventDefault();
        $('#headers-1-sidebar').removeClass('show');
    });
});

function recaptchaCallback(token) {
    $('button[type="submit"]').removeAttr('disabled').show();
    // document.getElementById('form').submit();
}

var mySwiper = new Swiper('#slider-customers-3', {
    speed: 400,
    navigation: {
      nextEl: '#slider-customers-3-next',
      prevEl: '#slider-customers-3-prev',
    },
    pagination: {
      el: '#slider-customers-3-pagination',
      clickable: true
    }
});

var mySwiper = new Swiper('#slider-right-7', {
    speed: 400,
    navigation: {
    nextEl: '#slider-right-7-next',
    prevEl: '#slider-right-7-prev',
    },
    pagination: {
    el: '#slider-right-7-pagination',
    clickable: true
    }
});


var mySwiper = new Swiper('#slider-left-7', {
    speed: 400,
    navigation: {
      nextEl: '#slider-left-7-next',
      prevEl: '#slider-left-7-prev',
    },
    pagination: {
      el: '#slider-left-7-pagination',
      clickable: true
    }
  });


var mySwiper11 = new Swiper('#slider-gallery-11', {
    speed: 400,
    navigation: {
        nextEl: '.slider-gallery-11-next',
        prevEl: '.slider-gallery-11-prev',
    },
    pagination: {
    el: '#slider-gallery-11-pagination',
    clickable: true
    },
    slidesPerView: 'auto'
});
var mySwiper111 = new Swiper('#slider-gallery-111', {
    speed: 400,
    navigation: {
        nextEl: '.slider-gallery-111-next',
        prevEl: '.slider-gallery-111-prev',
    },
    pagination: {
    el: '#slider-gallery-111-pagination',
    clickable: true
    },
    slidesPerView: 'auto'
});


$('.app_btn_trigger').on('click', function(e) {
    var isMobile = RegExp(/Android|webOS|iPhone|iPod|iPad/i).test(navigator.userAgent);
    var ios = RegExp(/Macintosh/i).test(navigator.userAgent);
    var android = RegExp(/Android/i).test(navigator.userAgent);
    if (!isMobile) {
        if ( ios && navigator.maxTouchPoints && navigator.maxTouchPoints > 2 ) {
            isMobile = true;
        } else if (android ) {
            isMobile = true;
        } else {
            e.preventDefault();
            alert('Link must be accessed from a mobile device.');
        }
    }
});
